import React from "react";
import { Provider } from "./context";
import { Form, Input } from "antd";
import {
  useChange,
  useStoreToForm,
  useInit,
  useFormateMsg,
  useIsMoblie,
} from "./hooks";
import Questions from "./components/Questions";
import Previews from "./components/PreViews";
import Footer from "./components/Footer";
import Header from "./components/Header";
import TipsPage from "./components/TipsPage";
import "./styles/app.scss";
import { useSelector } from "react-redux";
import { FormContext } from "./context/form";

function App() {
  const [form] = Form.useForm();
  const { storageModal, tipsPage } = useSelector((state) => state.app);
  const { handler: handleChange } = useChange(form);
  const { handler: stoageHandler } = useStoreToForm(form);
  const { loading } = useInit(form);
  const { formatMsg } = useFormateMsg();
  const isMoblie = useIsMoblie();
  return (
    <div className={`app ${isMoblie ? "mobile" : "pc"}`}>
      {storageModal && (
        <div className="storage-modal bg-modal">
          <div className="storage-box">
            <div className="title">{formatMsg("tips")}</div>
            <div className="text">{formatMsg("againTxt")}</div>
            <div className="btn-bar">
              <div onClick={() => stoageHandler(false)}>
                {formatMsg("cancel")}
              </div>
              <div className="main" onClick={() => stoageHandler(true)}>
                {formatMsg("confirm")}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="survey-box">
        <Form form={form} onValuesChange={handleChange}>
          <FormContext.Provider value={{ form }}>
            {!loading && (
              <React.Fragment>
                <Provider value={{ form: form }}>
                  <Form.Item hidden name="suveryInfo">
                    <Input hidden></Input>
                  </Form.Item>
                  <Form.Item hidden name="postAnswer">
                    <Input hidden></Input>
                  </Form.Item>
                  {!tipsPage.status && (
                    <React.Fragment>
                      <div className="survey">
                        <Header></Header>
                        <Form.Item
                          noStyle
                          shouldUpdate={(prev, cur) =>
                            prev.suveryInfo?.questionList !=
                            cur.suveryInfo?.questionList
                          }
                        >
                          {({ getFieldValue }) => {
                            let list = getFieldValue([
                              "suveryInfo",
                              "questionList",
                            ]);
                            return (
                              <Questions list={list} form={form}></Questions>
                            );
                          }}
                        </Form.Item>
                      </div>
                      <Footer form={form}></Footer>
                    </React.Fragment>
                  )}
                </Provider>
                <Previews></Previews>
              </React.Fragment>
            )}
          </FormContext.Provider>
        </Form>
      </div>
      {tipsPage.status && <TipsPage />}
    </div>
  );
}

export default App;
